// import React from "react";
// import { Link } from "react-router-dom";
// import Usernav from "../usernav/usernav";
// import { IoPerson } from "react-icons/io5";
// import "./userhome.css"
// const UserHome = () => {
//     return (
//         <>
//             <div className="breadcrumb-wrap bg-f br-2 mt-5">
//                 <div className="container">
//                     <div className="breadcrumb-title">
//                         <h2>My Profile</h2>
//                         <ul className="breadcrumb-menu list-style">
//                             <li><Link to="#">Home </Link></li>
//                             <li>My Profile</li>
//                         </ul>
//                     </div>
//                 </div>
//             </div>


//             <div >
//                 <div className="profilecon">
//                     <Usernav />
//                     <div class="col-xl-8 col-lg-12 profile">
//                         <div className="d-flex"><div className="person"><IoPerson /></div> <span style={{ fontSize: "20px" }}>My Profile</span></div>
//                         <div className=" usercontiner">
//                             <div className="name"></div>
//                             <div className="order"> All Orders</div>

//                             <div className="ship">Awaiting Shipment</div>
//                             <div className="dilivery">Awaiting Delivery</div>
//                         </div>
//                         <div className="user">
//                             <div><h6>First Name</h6><p>user.firstname</p></div>
//                             <div><h6>Last Name</h6><p>user.lastnamea</p></div>
//                             <div><h6>Email</h6><p>user.email</p></div>
//                             <div><h6>Phone</h6><p>user.phone</p></div>
//                             <div><h6>Birth date</h6><p>user.dob</p></div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };
// export default UserHome;


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import Usernav from "../usernav/usernav";
// import { IoPerson } from "react-icons/io5";
// import "./userhome.css";

// const UserHome = () => {
//   const [user, setUser] = useState({
//     firstname: "",
//     lastname: "",
//     email: "",
//     mob_number: "",
//     dob: "",
//     password: "",
//   });
//   const [isEditing, setIsEditing] = useState(false);
//   const [isNewUser, setIsNewUser] = useState(false);

//   const userId = "USER_ID"; // Replace with dynamic user ID from context/auth

//   // Fetch user data
//   useEffect(() => {
//     const fetchUser = async () => {
//       try {
//         const response = await axios.get(`/api/profile/${userId}`);
//         if (response.data) {
//           setUser(response.data);
//         } else {
//           setIsNewUser(true);
//         }
//       } catch (error) {
//         console.error("Error fetching user", error);
//         setIsNewUser(true); // Assume new user if fetch fails
//       }
//     };
//     fetchUser();
//   }, [userId]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setUser({ ...user, [name]: value });
//   };

//   const saveProfile = async () => {
//     try {
//       if (isNewUser) {
//         // POST request for new user
//         const response = await axios.post('/api/profile', user);
//         alert(response.data.message);
//       } else {
//         // PUT request for existing user
//         const response = await axios.put(`/api/profile/${userId}`, user);
//         alert(response.data.message);
//       }
//       setIsEditing(false);
//       setIsNewUser(false); // Switch to existing user mode after saving
//     } catch (error) {
//       console.error("Error saving profile", error);
//       alert("Failed to save profile");
//     }
//   };

//   return (
//     <>
//       <div className="breadcrumb-wrap bg-f br-2 mt-5">
//         <div className="container">
//           <div className="breadcrumb-title">
//             <h2>My Profile</h2>
//             <ul className="breadcrumb-menu list-style">
//               <li><Link to="#">Home </Link></li>
//               <li>My Profile</li>
//             </ul>
//           </div>
//         </div>
//       </div>
//       <div className="profilecon">
//         <Usernav />
//         <div className="col-xl-8 col-lg-12 profile">
//           <div className="d-flex">
//             <div className="person"><IoPerson /></div>
//             <span style={{ fontSize: "20px" }}>My Profile</span>
//           </div>
//           <div className="user">
//             {(isEditing || isNewUser) ? (
//               <>
//                 <div>
//                   <h6>First Name</h6>
//                   <input
//                     type="text"
//                     name="firstname"
//                     value={user.firstname}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div>
//                   <h6>Last Name</h6>
//                   <input
//                     type="text"
//                     name="lastname"
//                     value={user.lastname}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div>
//                   <h6>Email</h6>
//                   <input
//                     type="email"
//                     name="email"
//                     value={user.email}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div>
//                   <h6>Phone</h6>
//                   <input
//                     type="text"
//                     name="mob_number"
//                     value={user.mob_number}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div>
//                   <h6>Birth Date</h6>
//                   <input
//                     type="date"
//                     name="dob"
//                     value={user.dob}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div>
//                   <h6>Password</h6>
//                   <input
//                     type="password"
//                     name="password"
//                     value={user.password}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <button onClick={saveProfile} className="btn btn-primary">
//                   {isNewUser ? "Add" : "Save"}
//                 </button>
//               </>
//             ) : (
//               <>
//                 <div><h6>First Name</h6><p>{user.firstname}</p></div>
//                 <div><h6>Last Name</h6><p>{user.lastname}</p></div>
//                 <div><h6>Email</h6><p>{user.email}</p></div>
//                 <div><h6>Phone</h6><p>{user.mob_number}</p></div>
//                 <div><h6>Birth Date</h6><p>{user.dob}</p></div>
//                 <div><h6>Password</h6><p>******</p></div>
//                 <button
//                   onClick={() => setIsEditing(true)}
//                   className="btn btn-secondary"
//                 >
//                   Edit
//                 </button>
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default UserHome;
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Usernav from "../usernav/usernav";
import { MdEdit } from "react-icons/md";
import { IoPerson } from "react-icons/io5";
import "./userhome.css";

const UserHome = () => {
  const [user, setUser] = useState({
    firstname: "",
    lastname: "",
    email: "",
    mob_number: localStorage.getItem("phoneNumber"),
    dob: "",
    password: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);

  const phoneNumber = localStorage.getItem("phoneNumber");


  // Fetch user data if phoneNumber exists
  useEffect(() => {
    const fetchUser = async () => {
      if (!phoneNumber) {
        setIsNewUser(true);
        return;
      }
      try {
        const response = await axios.get(
          `/api/profile?phone=${phoneNumber}`
        );
        if (response.data) {
          setUser(response.data);
          setIsNewUser(false);
        } else {
          setIsNewUser(true);
        }
      } catch (error) {
        console.error("Error fetching user", error);
        setIsNewUser(true); // Assume new user if fetch fails
      }
    };
    fetchUser();
  }, [phoneNumber]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  const saveProfile = async () => {
    try {
      if (isNewUser) {
        // POST request for new user
        const response = await axios.post("/api/profile", user);
        alert(response.data.message);
        localStorage.setItem("phoneNumber", user.mob_number); // Save phone number to localStorage
      } else {
        // PUT request for existing user
        const response = await axios.put(
          `/api/profile/${user.mob_number}`,
          user
        );
        alert(response.data.message);
      }
      setIsEditing(false);
      setIsNewUser(false); // Switch to existing user mode after saving
    } catch (error) {
      console.error("Error saving profile", error);
      alert("Failed to save profile");
    }
  };

  return (
    <>
      <div className="breadcrumb-wrap bg-f br-2">
        <div className="container">
          <div className="breadcrumb-title">
            <h2>My Profile</h2>
            <ul className="breadcrumb-menu list-style">
              <li><Link to="/">Home </Link></li>
              <li>My Profile</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="containerorder">
        <div className="row ">
          <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
          <Usernav /></div>
          <div className="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
            <div className="d-flex">
              <div className="person"><IoPerson /></div>
              <span style={{ fontSize: "20px" }}>My Profile</span>
            </div>
            {/* <div className=" usercontiner">
              <div className="order"> Total Orders <br /><span>10</span></div>
              <div className="ship">Awaiting Shipment <br /><span>10</span></div>
              <div className="dilivery">Awaiting Delivery <br /><span>10</span></div>
            </div> */}
            <div className="user">
              {(isEditing || isNewUser) ? (
                <>
                  <div>
                    <h6>First Name</h6>
                    <input
                      className="profileinput"
                      type="text"
                      name="firstname"
                      value={user.firstname}
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <h6>Last Name</h6>
                    <input
                      className="profileinput"
                      type="text"
                      name="lastname"
                      value={user.lastname}
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <h6>Email</h6>
                    <input
                      className="profileinput"
                      type="email"
                      name="email"
                      value={user.email}
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <h6>Phone</h6>
                    <input
                      className="profileinput"
                      type="text"
                      name="mob_number"
                      value={user.mob_number}
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <h6>Password</h6>
                    <input
                      className="profileinput"
                      type="password"
                      name="password"
                      value={user.password}
                      onChange={handleChange}
                    />
                  </div>
                  <button onClick={saveProfile} className="profilesavebutton">
                    {isNewUser ? "Add" : "Save"}
                  </button>
                </>
              ) : (
                <>
                  <div><h6>First Name</h6><p>{user.firstname}</p></div>
                  <div><h6>Last Name</h6><p>{user.lastname}</p></div>
                  <div><h6>Email</h6><p>{user.email}</p></div>
                  <div><h6>Phone</h6><p>{user.mob_number}</p></div>
                  {/* <div><h6>Birth Date</h6><p>{user.dob}</p></div> */}
                  <div><h6>Password</h6><p>******</p></div>
                  <button
                    onClick={() => setIsEditing(true)}
                    className="userdeditbtn"
                  >
                    <MdEdit />
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserHome;
